<template>
	<div class="classified-resume">
		<div class="pa-block">
			<h3 class="selector-title">Récapitulatif de l'offre</h3>
			<div class="pa-block__inner pa-block__inner--flex">
				<div class="pa-block__main">
					<fieldset>
						<legend>Vous avez selectionné :</legend>
					</fieldset>
					<table>
						<tr>
							<td>Profil:</td>
							<td>
								<strong>
									{{
										classified.profil == "proflib"
											? "Professionnel de santé"
											: "Établissement"
									}}
								</strong>
							</td>
						</tr>
						<tr v-if="classified.category">
							<td>Type d'annonce</td>
							<td>
								<strong>{{ categoryName(classified.category).name }}</strong>
							</td>
						</tr>
						<tr>
							<td>Support de publication :</td>
							<td>
								<strong>{{
									classified.mode == "print_web" ? "Presse + web" : "Web"
								}}</strong>
							</td>
						</tr>
						<tr>
							<td>Offre :</td>
							<td>
								<strong>
									{{
										classified.format == "simple"
											? classified.mode == "print_web"
												? "Annonce simple"
												: "Annonce web"
											: classified.format + "e de page"
									}}
								</strong>
							</td>
						</tr>
						<tr>
							<td>Durée :</td>
							<td>
								<strong>
									{{ parseInt(classified.duration) }}
									{{
										classified.mode == "print_web"
											? "semaine" +
											  (parseInt(classified.duration) > 1 ? "s" : "")
											: "mois"
									}}
								</strong>
							</td>
						</tr>
					</table>
				</div>
				<!-- pa-block__main -->
				<div class="pa-block__sidebar">
					<fieldset>
						<legend>Récapitulatif commande :</legend>
					</fieldset>
					<table>
						<thead>
							<tr>
								<td>
									<strong>
										{{
											classified.format == "simple"
												? classified.mode == "print_web"
													? "Annonce simple"
													: "Annonce web"
												: classified.format + "e de page"
										}}
										({{ parseInt(classified.duration) }}
										{{
											classified.mode == "print_web"
												? "semaine" +
												  (parseInt(classified.duration) > 1 ? "s" : "")
												: "mois"
										}})
									</strong>
								</td>
								<td>
									<strong>
										{{
											numberFormat(
												getPrice(classified, {
													tva: true,
													with_options: false,
													with_membership_discount: false,
													include_diff_abcdent: includeDiffAbcdentPrice,
												})
											)
										}}
										€ <small>TTC</small>
									</strong>
								</td>
							</tr>

							<tr
								v-for="option in [
									'background',
									'urgent',
									'move_top',
									'domiciliation',
									'diff_abcdent',
									'diff_abcdent_pro',
								]"
								v-bind:key="option"
								:class="{
									hidden:
										classified['option_' + option] == 0 ||
										!classified['option_' + option],
								}"
							>
								<td>
									<strong>
										<span v-html="optionName(option)"></span>
										({{ parseInt(classified.duration) }}
										{{
											classified.mode == "print_web"
												? "semaine" +
												  (parseInt(classified.duration) > 1 ? "s" : "")
												: "mois"
										}})
									</strong>
								</td>
								<td>
									<strong>
										{{
											numberFormat(
												getPrice(classified, {
													tva: true,
													only_option: option,
													with_membership_discount: false,
													include_diff_abcdent: includeDiffAbcdentPrice,
												})
											)
										}}
										€ <small>TTC</small>
									</strong>
								</td>
							</tr>

							<tr
								v-for="media in classified.medias"
								v-bind:key="media"
								:class="{ hidden: classified.format !== 'simple' }"
							>
								<td>
									<strong>
										{{ optionName("media") }}
										({{ parseInt(classified.duration) }}
										{{
											classified.mode == "print_web"
												? "semaine" +
												  (parseInt(classified.duration) > 1 ? "s" : "")
												: "mois"
										}})
									</strong>
								</td>
								<td>
									<strong>
										{{
											numberFormat(
												getPrice(classified, {
													tva: true,
													only_option: "media",
													with_membership_discount: false,
												})
											)
										}}
										€ <small>TTC</small>
									</strong>
								</td>
							</tr>

							<tr v-if="parseInt(classified.membership)">
								<td>
									<strong>Remise abonné</strong>
								</td>
								<td>
									<strong>
										{{
											numberFormat(
												-getPrice(classified, {
													tva: true,
													with_membership_discount: false,
													include_diff_abcdent: includeDiffAbcdentPrice,
												}) *
													(getSettings.membership_discount / 100)
											)
										}}
										€ <small>TTC</small>
									</strong>
								</td>
							</tr>
						</thead>
						<tbody>
							<tr class="total">
								<td>
									<strong>Prix total TTC</strong>
								</td>
								<td>
									<strong>
										{{
											numberFormat(
												getPrice(classified, {
													include_diff_abcdent: includeDiffAbcdentPrice,
													with_options: true,
												})
											)
										}}
										€
									</strong>
								</td>
							</tr>
							<tr>
								<td>
									<strong>Prix total HT</strong>
								</td>
								<td>
									<strong>
										{{
											numberFormat(
												getPrice(classified, {
													tva: false,
													with_options: true,
													include_diff_abcdent: includeDiffAbcdentPrice,
												})
											)
										}}
										€
									</strong>
								</td>
							</tr>
							<tr>
								<td>
									<strong>Dont TVA</strong>
								</td>
								<td>
									<strong>
										{{
											numberFormat(
												getPrice(classified, {
													with_options: true,
													include_diff_abcdent: includeDiffAbcdentPrice,
												}) -
													getPrice(classified, {
														tva: false,
														with_options: true,
														include_diff_abcdent: includeDiffAbcdentPrice,
													})
											)
										}}
										€
									</strong>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="block-update">
						<div @click="goToStep1()">
							<span>Modifier</span>
							<svg width="12" height="12">
								<use xlink:href="#icon-arrow" />
							</svg>
						</div>
					</div>
				</div>
				<!-- pa-block__sidebar -->
			</div>
			<!-- .pa-block__inner -->
		</div>
		<!-- .pa-block -->
	</div>
	<!-- .classified-resume -->
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
export default {
	name: "classified-resume",
	computed: {
		...mapState(["classified"]),
		...mapGetters(["getSettings", "maxMedias", "isCurrentCategoryFree"]),
		includeDiffAbcdentPrice() {
			return (
				this.classified.mode !== "print_web" && !this.isCurrentCategoryFree
			);
		},
	},
	methods: {
		// ...mapMutations(["setStep"]),
		goToStep1() {
			this.setStep("1");
		},
		optionName(option) {
			switch (option) {
				case "background":
					return "Couleur de fond";
					break;
				case "move_top":
					return "Mise en avant";
					break;
				case "urgent":
					return 'Mention "Urgent"';
					break;
				case "domiciliation":
					return "Domiciliation";
					break;
				case "media":
					return "Photo supplémentaire";
					break;
				case "diff_abcdent":
					return (
						"Diffusion abcdent.pro" +
						(this.isCurrentCategoryFree || this.classified.mode === "print_web"
							? ' <span class="text-primary">INCLUS</span>'
							: "")
					);
					break;
				case "diff_abcdent_pro":
					return (
						"Diffusion abcdent.pro" +
						(this.isCurrentCategoryFree || this.classified.mode === "print_web"
							? ' <span class="text-primary">INCLUS</span>'
							: "")
					);
					break;
				default:
					return option;
					break;
			}
		},
		optionPrice(option) {
			return this.$store.state.settings.options[this.classified.profil][
				"option_" + option
			];
		},
		categoryName(category_id) {
			return this.$store.state.categories.find(
				(cat) => cat.term_id == category_id
			);
		},
	},
};
</script>

<style lang="scss" scoped>
label {
	display: block;
}
tr.hidden {
	display: none;
}
</style>
